<template>
    <div class="w-full bg-gray_2">
        <!-- PC 고객사 후기  -->
        <div class="w-full max-w-7xl min-h-[805px] new_lg:px-5 mx-auto hidden new_lg:flex flex-col pt-10 items-center">
            <p class="font-bold text-medium-size-0 text-text-0 tracking-[-0.0045em]">고객사 후기</p>
            <div class="grid grid-cols-2 gap-10 mt-[60px]">
                <CustomerReviewCard
                    v-for="(review, index) in reviews"
                    :key="index"
                    class="customer-review"
                    :avaratUrl="review.avatar"
                    :name="review.name"
                    :title="review.title"
                    :description="review.description"
                    :imagePosition="review.imagePosition" />
            </div>
            <Button
                class="rounded-full border-main-0 border-[1px] flex items-center justify-center w-[206px] h-[44px] mt-[60px] bg-white"
                @click="scrollToBottom">
                <p class="font-medium text-main-0 text-small-size">리드워크 문의하기</p>
            </Button>
        </div>

        <!-- 모바일 고객사 후기  -->
        <div
            class="flex flex-col items-center justify-center px-5 py-10 mx-auto bg-[#F6F6F6] new_lg:hidden">
            <p class="font-bold text-text-0 text-medium-size-2 text-center tracking-[-0.0045em] mb-7">고객사 후기
            </p>
            <div class="flex flex-col gap-3">
                <CustomerReviewCard
                    v-for="(review, index) in reviews"
                    :key="index"
                    class="customer-review"
                    :avaratUrl="review.avatar"
                    :name="review.name"
                    :title="review.mobileTitle || review.title"
                    :description="review.mobileDescription || review.description"
                    :imagePosition="review.imagePosition"
                    :isMobile="true" />
            </div>

            <Button
                class="rounded-full border-main-0 border-[1px] flex items-center justify-center w-[206px] h-[44px] mt-[40px] mb-10 bg-white"
                @click="scrollToBottom">
                <p class="font-medium text-main-0 new_lg:text-small-size-1">리드워크 문의하기</p>
            </Button>
        </div>
    </div>
</template>

<script>
import CustomerReviewCard from '@/components/sw/CustomerReviewCard.vue'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
    name: 'CustomerReviewSection',
    components: {
        CustomerReviewCard
    },
    data() {
        return {
            reviews: [
                {
                    avatar: require('@/assets/ic_avatar_001.png'),
                    name: '대형 커머스 기업 D사, 박 팀장**',
                    title: '비즈니스 이해 기반의 개발 제안이 인상적이었습니다',
                    description: '단순 구현이 아니라 사용자 흐름과 운영 효율까지 고려된 제안을 통해 내부 설득까지 수월했습니다.',
                    imagePosition: 'left'
                },
                {
                    avatar: require('@/assets/ic_avatar_002.png'),
                    name: '핀테크 기업 F사, 전** 본부장',
                    title: '단기간에 안정적인 구성과 품질까지 확보해 주셨습니다',
                    description: '릴리즈 직전 긴급 투입이었음에도 QA 기반의 완성도 있는 결과물을 내어주셔서 매우 신뢰가 갔습니다.',
                    imagePosition: 'right'
                },
                {
                    avatar: require('@/assets/ic_avatar_003.png'),
                    name: 'B2B SaaS 기업 S사, 이 대표**',
                    title: '개발 이후 운영 단계까지 책임지는 파트너십이 확실합니다',
                    description: '런칭 후 개선 및 유지보수까지 유기적으로 이어져, 외주라기보단 실질적인 내부 팀처럼 함께하고 있습니다.',
                    imagePosition: 'left'
                },
                {
                    avatar: require('@/assets/ic_avatar_004.png'),
                    name: '교육 플랫폼 E사, 김 실장**',
                    title: '커뮤니케이션 속도와 대응력이 빠릅니다',
                    description: '요구 사항 정리부터 스펙 제안까지 명확해, 매번 협업이 빠르고 깔끔하게 진행되고 있습니다.',
                    imagePosition: 'right'
                },
                {
                    avatar: require('@/assets/ic_avatar_005.png'),
                    name: '글로벌 서비스 확장 준비 중인 M사, 윤 팀장**',
                    title: '초기 MVP 단계부터 글로벌 확장까지 믿고 맡길 수 있었습니다',
                    description: '클라우드 기반 설계부터 다국어 대응까지 고려된 구조 덕분에 확장 대응 비용이 크게 절감되었습니다.',
                    imagePosition: 'left'
                },
                {
                    avatar: require('@/assets/ic_avatar_006.png'),
                    name: '리테일 기업 R사, 장 이사**',
                    title: '서비스 성격에 맞춘 품질 기준 제안이 매우 전문적이었습니다',
                    description: '단순 기능 구현이 아니라 실제 사용자 상황에서 발생할 리스크까지 선제적으로 검토해 주셔서 신뢰가 컸습니다.',
                    imagePosition: 'right'
                }
            ]
        }
    },
    mounted() {
        gsap.utils.toArray('.customer-review').forEach((element) => {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                    y: 100,
                },
                {
                    opacity: 1,
                    y: 0,
                    duration: 1,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: element,
                        start: 'top 80%',
                        toggleActions: 'play none none none',
                    },
                }
            );
        });
    },
    methods: {
  scrollToBottom() {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth"
    });
  }
}
}
</script>

<style scoped>
:deep(.customer-review) {
    opacity: 0;
    transform: translateY(50px);
}
</style>
